import { Box, Tabs, Tab, CircularProgress, Zoom, ClickAwayListener, Divider, FormControl, IconButton, InputLabel, TextField, Typography } from "@material-ui/core";
import { useTheme } from '@material-ui/core/styles';
import { useEffect, useState } from "react";
import useStyles from '../../../assets/styles/styles';
import SwipeableViews from "react-swipeable-views";
import TabPanel from "../../../controls/TabPanel/TabPanel";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import NotFound from "../../HomeLogged/NotFound";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useResizeScreen } from "../../../hooks/useResizeScreen";
import { showErrorMessageModal } from "../../../utils/utilsFunctions";
import { useLocation } from 'react-router-dom';
import Menu from "../../Menu/Menu";
import Header from "../../GenericHeader/Header";


const PrescriptionDetail = () => {
    const classes = useStyles();
    const { screen } = useResizeScreen();
    const [value, setValue] = useState(0);
    const theme = useTheme();
    const history = useHistory();
    const [openError, setOpenError] = useState();

    const location = useLocation();
    const selectedItem = location.state?.item;

    const handleChange = (e, newValue) => {
        setValue(newValue);
    };

    const handleChangeIndex = (index) => {
        setValue(index);
    };


    function axisValue(condition) {
        var response = '';
        if (condition === 'rtl') {
            response = 'x-reverse';
        } else {
            response = 'x';
        }
        return response;
    }

    const PrescriptionDetails = ({ selectedItem, value, handleChange, handleChangeIndex, theme, classes, history }) => {
        if (!selectedItem) {
            return (
                <NotFound customMsg={
                    <div className={classes.contentNotFound}>
                        <span className={classes.notAppointment}>No hay contenido para mostrar</span>
                    </div>
                } />
            );
        }

        return (
            <Box>
                <IconButton
                    onClick={() => history.push('/PrescriptionPage')}
                    style={{ marginLeft: screen.sWidth > 900 ? "60px" : "25px", marginTop: "20px" }}
                >
                    <ArrowBackIcon className={classes.iconFilter} />
                </IconButton>

                <div className={classes.prescriptionHeader}>
                    <Tabs className={classes.prescriptionTabs} value={value} onChange={handleChange} centered>
                        <Tab label="CABECERA" />
                        <Tab label="DETALLE" />
                    </Tabs>
                </div>

                <SwipeableViews
                    style={{ overflow: 'hidden' }}
                    axis={axisValue(theme.direction)}
                    index={value}
                    onChangeIndex={handleChangeIndex}
                >
                    <TabPanel value={value} index={0} dir={theme.direction}>
                        <Box style={{ padding: '5%' }} className={classes.boxContent}>
                            <Typography style={{ fontSize: '14px', fontWeight: "600", color: '#0075c9' }} className={`${classes.txtCardDescription}`}>
                                RESUMEN DE LA INFORMACION
                            </Typography>
                            <Typography className={`${classes.txtCardDescription} ${classes.textLabelPrescriptionPageDetail}`}>
                                Tipo y Número: <span style={{ color: '#0075c9' }}> {selectedItem.recetaClasificacion} Nro {selectedItem.recetaNumero}  </span>
                            </Typography>
                            <Typography className={`${classes.txtCardDescription} ${classes.textLabelPrescriptionPageDetail}`}>
                                Estado: <span style={{ color: '#0075c9' }}>{selectedItem.recetaEstado}</span>
                            </Typography>
                            <Typography className={`${classes.txtCardDescription} ${classes.textLabelPrescriptionPageDetail}`}>
                                FECHA:
                                <span style={{ fontWeight: '500', marginLeft: '5px' }}>
                                    {new Date(selectedItem.recetaFechaVigenciaDesde?.replace(/\s/, 'T'))?.toLocaleDateString('es-ES')}
                                </span>
                            </Typography>
                            <Typography className={`${classes.txtCardDescription} ${classes.textLabelPrescriptionPageDetail}`}>
                                Vencimiento:
                                <span style={{ fontWeight: '500', marginLeft: '5px' }}>
                                    {new Date(selectedItem.recetaFechaVigenciaHasta?.replace(/\s/, 'T'))?.toLocaleDateString('es-ES')}
                                </span>
                            </Typography>
                            <Typography className={`${classes.txtCardDescription} ${classes.textLabelPrescriptionPageDetail}`}>
                                Médico: <span> {selectedItem.recetaMedicoNombre}</span>
                            </Typography>
                            <Typography className={`${classes.txtCardDescription} ${classes.textLabelPrescriptionPageDetail}`}>
                                Matrícula:  <span> {`${selectedItem.recetaMedicoMatriculaTipo || ''} ${selectedItem.recetaMedicoMatriculaNumero || ''} ${selectedItem.recetaMedicoMatriculaProvincia || ''}`}</span>
                            </Typography>
                            <Typography className={`${classes.txtCardDescription} ${classes.textLabelPrescriptionPageDetail}`}>
                                Observación:  <span> {selectedItem.recetaObservacion}</span>
                            </Typography>
                        </Box>
                    </TabPanel>

                    <TabPanel value={value} index={1} dir={theme.direction}>
                        <Box style={{ padding: '5%' }} className={classes.boxContent}>
                            {selectedItem.recetaDetalle?.length > 0 &&
                                selectedItem.recetaDetalle
                                    .sort((a, b) => a.recetaDetalleItem - b.recetaDetalleItem)
                                    .map((detalle, i) => (
                                        <Box key={i} style={{ marginBottom: '16px' }}>
                                            <Typography style={{ fontSize: '14px', fontWeight: "600", color: '#0075c9' }} className={`${classes.txtCardDescription}`}>
                                                Item: <span>{i + 1}</span>
                                            </Typography>
                                            <Typography className={`${classes.txtCardDescription} ${classes.textLabelPrescriptionPageDetail}`}>
                                                Descripción: <span>{detalle.recetaDetalleProductoDescripcion}</span>
                                            </Typography>
                                            {detalle.recetaDetalleProductoCantidad > 0 && (
                                                <Typography className={`${classes.txtCardDescription} ${classes.textLabelPrescriptionPageDetail}`}>
                                                    Cantidad: <span>{detalle.recetaDetalleProductoCantidad}</span>
                                                </Typography>
                                            )}
                                            <Typography className={`${classes.txtCardDescription} ${classes.textLabelPrescriptionPageDetail}`}>
                                                Sustitución: <span>{detalle.recetaDetalleSustitucion ? 'Sí' : 'No'}</span>
                                            </Typography>
                                        </Box>
                                    ))}
                        </Box>
                    </TabPanel>
                </SwipeableViews>
            </Box>
        );
    };


    return (
        <>
            <Menu />
            <Header title={selectedItem?.recetaClasificacion} />
            <PrescriptionDetails
                selectedItem={selectedItem}
                value={value}
                handleChange={handleChange}
                handleChangeIndex={handleChangeIndex}
                theme={theme}
                classes={classes}
                history={history}
            />
            {showErrorMessageModal(null, openError, setOpenError, classes.borderWhite, classes.quickAccessIcon)}
        </>
    );
};

export default PrescriptionDetail;
